import React from "react";
import DeviceCard from "../DeviceCard";
import DeviceListLoader from "./DeviceListLoader";

const DeviceListStackedView = (props) => {
    const {
        isLoading, 
        deviceData, 
        selectedDeviceInfo,
        onSelectDevice
    } = props;

    return(
        <>
            <div className="my-devices-list-stacked-view">
                {
                    (isLoading)
                    ? (
                        [...Array(5)].map((_, index) => (
                           <DeviceListLoader cname="stacked-card-loader"/>
                        ))
                    )
                    : (
                        Object.keys(deviceData).length > 0 
                        &&  Object.values(deviceData).map((device, index) => (
                            <DeviceCard
                                cname="stacked-card"
                                key={index}
                                device={device}
                                index={index}
                                selectedDevice={selectedDeviceInfo}
                                onClick={onSelectDevice}
                                displayPrinterImage={false}
                            />
                        ))
                    )
                }
            </div>
        </>
    )
}

export default DeviceListStackedView;